import { Pipe, PipeTransform } from '@angular/core';
import { ReportExtensions } from '@spa/api';
import { Language } from '../language';
import { LanguageService } from '../language.service';

@Pipe({
    name: 'formatInteger'
})
export class FormatIntegerPipe implements PipeTransform {
    constructor(private languageService: LanguageService) { }

    transform(value: number, sign?: string, addSpace?: boolean): string {
        let result = ReportExtensions.toIntegerString(value, false);

        if (this.languageService.getCurrentLanguage() === Language.Bulgarian) {
            result = result.replace(/,/g, ' ');
        }

        if (sign) {
            if (addSpace) {
                return `${sign} ${result}`;
            }

            return `${sign}${result}`;
        }

        return result;
    }
}
